import React from 'react';
import { AtomIcon, BookOpenIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: AtomIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and educators'
}];
export function SocialProof() {
  return <section className="border-y border-slate-300/20 bg-blue-950 py-5" aria-label="What the teacher ready includes" data-id="element-220" data-mp="3ev7l0v8owgt">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-white sm:justify-between" data-id="element-221" data-mp="8ehkf975oap3">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-222" data-mp="3usr6vcriz8n8">
            <Icon className="h-5 w-5 text-slate-300" aria-hidden="true" data-id="element-223" data-mp="mdzbxwbu6225" /> {label}
          </span>)}
      </div>
    </section>;
}